import React from "react";
import "./About.css";
import TeamImage from "./assets/team.png";
import SteinImg from "./assets/stein.jpg";
import WagnerImg from "./assets/wagner.jpg";
import ExpertenLogo from "./assets/eek-experten-logo.png";

export default function About() {
  return (
    <section id="about" className="about-section">
      <h2 className="about-title">Über uns</h2>

      {/* Zwei-Spalten Layout */}
      <div className="about-container">
        <div className="about-text">
          <p className="intro">
            Wir sind das <strong>Ingenieurbüro Stein & Wagner</strong> –
            Ihr zuverlässiger Partner für qualifizierte Energieberatung
            in Koblenz und Umgebung. Mit technischem Know-how,
            modernen Analysemethoden und einem klaren Blick für
            Wirtschaftlichkeit begleiten wir Eigentümer
            auf dem Weg zu energieeffizienten Gebäuden.
          </p>

          <ul className="about-list">
            <li>Wir sind zertifizierte Energieeffizienz-Experten und bilden uns kontinuierlich fort</li>
            <li>Unabhängige & förderfähige Energieberatung</li>
            <li>Präzise Berechnungen auf Basis aktueller DIN-Normen</li>
            <li>Persönliche Betreuung – von der Beratung bis zur Umsetzung</li>
            <li>Individuelle Konzepte statt Standardlösungen</li>
          </ul>

          <p className="mission">
            Unser Anspruch ist es, für jedes Gebäude die optimale Lösung zu finden – technisch sinnvoll, wirtschaftlich tragfähig und zukunftssicher.
          </p>
        </div>

        {/* Bild rechts vom Text */}
        <div className="about-image">
          <img src={TeamImage} alt="Team Stein & Wagner" />
        </div>
      </div>

      {/* Ansprechpartner unterhalb */}
      <div className="team-contacts">
        <h3>Ihre Ansprechpartner</h3>
        <div className="contact-cards-container">
          <div className="contact-card">
            <img src={SteinImg} alt="Alexander Stein" className="profile-image" />
            <div className="contact-info">
              <p><strong>Alexander Stein</strong></p>
              <p>
                E-Mail:{" "}
                <a
                  href="mailto:alexander.stein@suw-ing.de"
                  className="email-link"
                >
                  alexander.stein@suw-ing.de
                </a>
              </p>
              <p>Telefon: <a href="tel:+4926194297645">+49 (0)261 94297645</a></p>
              <img src={ExpertenLogo} alt="Energie Effizienz Experte" className="experten-logo" />
            </div>
          </div>

          <div className="contact-card">
            <img src={WagnerImg} alt="Sebastian Wagner" className="profile-image" />
            <div className="contact-info">
              <p><strong>Sebastian Wagner</strong></p>
              <p>
                E-Mail:{" "}
                <a
                  href="mailto:sebastian.wagner@suw-ing.de"
                  className="email-link"
                >
                  sebastian.wagner@suw-ing.de
                </a>
              </p>
              <p>Telefon: <a href="tel:+4926194297644">+49 (0)261 94297644</a></p>
              <img src={ExpertenLogo} alt="Energie Effizienz Experte" className="experten-logo" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
